






import { Component, Watch, Vue } from 'vue-property-decorator';
import Route from 'vue-router';
import EditReport from '@/components/EditReport.vue'; // @ is an alias to /src

@Component({
  components: {
    EditReport,
  },
})
export default class Report extends Vue {
  pageId:string = ""

  mounted() {
    this.pageId = this.$route.params.id
  }

  @Watch('$route')
  onRouteUpdate(val:Route, newVal:Route) {
    this.pageId = this.$route.params.id
  }
}
